import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Accommodation = () => {
  const show = true;
  if (show) {

    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2026" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">

            <div className="announce">
            <h2>The information is to be announced. </h2>
              {/*下面我刚加的，先注释掉*/}   
              {/* <h2>Accommodation information for Chengdu will be announced soon.</h2>
              <p>
                The organizing committee is negotiating preferential room rates near the planned venue in Chengdu&apos;s
                Tianfu New Area. Recommended hotels, booking links, and transportation tips will be published on this
                page once finalized.
              </p>
              <p>
                Please subscribe to our newsletter or follow the official WeChat account <strong>ICSI_Secretariat</strong>
                for real-time updates. If you have urgent accommodation requirements, contact{" "}
                <a href="mailto:icsi2026@iasei.org">icsi2026@iasei.org</a>.
              </p> */}
            </div>

          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Accommodation | ICSI 2026" />
        <Header />
        <Breadcrumb
          image="images/banner/banner.jpg"
          title="Accommodation"
          content="For Participants"
          contentTwo="Accommodation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content1">
            <h1>ICSI 2026 Recommended Hotels</h1>

            <div className="hotel">
              <h2>KEIKYU EX HOTEL MINATOMIRAI YOKOHAMA</h2>
              <div className="gallery">
                <img src="./images/hotel/dd61f15d.webp" width={600} alt="Exterior view"/>
                  <img src="./images/hotel/77d8161a.avif" width={600} alt="Modern room"/>
                  </div>
                  <div className="details">
                    <p><strong>Address:</strong> 4-3-6 Minatomirai, Nishi-ku, Yokohama (3-minute walk from Shin-Takashima Station)</p>
                    <p><strong>Key Features:</strong></p>
                    <ul>
                      <li>Panoramic city views from rooms</li>
                      <li>Free Wi-Fi and 24-hour convenience store</li>
                      <li>Connected to KT Zepp Yokohama concert venue</li>
                    </ul>
                    <a href="https://www.tokyuhotels.co.jp/yokohama-r/" className="button" >Official Site</a>
                  </div>
              </div>


              <div className="hotel">
                <h2>The Square Hotel Yokohama Minatomirai</h2>
                <div className="gallery">
                  <img src="./images/hotel/71305ea9.avif" width={600}/>
                    <img src="./images/hotel/4dc0fc10.webp" alt="Bay view" width={600}/>
                    </div>
                    <div className="details">
                      <p><strong>Address:</strong> Minatomirai 2-chome area (1-minute walk from Minatomirai Station)</p>
                      <ul>
                        <li>Direct access to shopping complexes</li>
                        <li>15-minute walk to Landmark Tower</li>
                        <li>Modern Italian restaurant on-site</li>
                      </ul>
                      <a href="https://www.mgphotels.com" className="button" >Book Now</a>
                    </div>
                </div>

                <div className="hotel">
                  <h2>Keikyu EX Hotel Minatomirai Yokohama</h2>
                  <div className="gallery">
                    <img src="./images/hotel/49687682.webp" alt="Hotel entrance" width={600}/>
                      <img src="./images/hotel/a59a1081.webp" alt="Compact room" width={600}/>
                      </div>
                      <div className="details">
                        <p><strong>Address:</strong> Near Sakuragicho Station (8-minute walk)</p>
                        <ul>
                          <li>Budget-friendly option</li>
                          <li>24-hour airport shuttle</li>
                          <li>Near historical Yamashita Park</li>
                        </ul>
                        <a href="https://sotetsu-hotels.com" className="button" >View Rates</a>
                      </div>
                  </div>

                  <p><em>All hotels are within 15–20 minutes by train to Kanagawa University.</em></p>
                </div>
                
                <div>
                  {/* <h2>The information is to be announced. </h2> */}

                </div>
              </EmptyTwo>
              {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
              <Footer />
              <ScrollToTop />
            </React.Fragment>
            );
  }
};

            export default Accommodation;
